"use client";
import Button from "@/common/Button";
import DropdownMenu from "@/common/DropdownMenu";
import Link from "next/link";
import React, { useState } from "react";
import Cookies from "js-cookie";
import { ArrowDown2 } from "iconsax-react";
import ConfirmToast from "@/common/ConfirmToast";
import { useRouter } from "next/navigation";

function UserDropDown() {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const router = useRouter();
  const name = Cookies.get("name");

  const logOutUserFromWebsite = () => {
    Cookies.remove("AccessToken");
    Cookies.remove("mobileNumber");
    Cookies.remove("name");
    setTimeout(() => {
      if (typeof window !== "undefined") window.location.reload();
    }, 800);
    router.push("/login");
  };
  const isValidName = (name: string) => {
    return name && name.trim() !== "" && name !== "null" && name !== "nullnull";
  };
  return (
    <>
      <DropdownMenu
        direction="rtl"
        menuClass="p-5  top-10 left-0 flex flex-col gap-3 items-start dashboard-dropdown"
        customeClass="w-max  px-1 rounded-full border-2 border-ws-gray-600 hidden sm:flex"
        trigger={
          <Button variant="primary" className="h-8 px-3">
            <span className=" ws-gray-500">
              {isValidName(String(name)) ? name : "کاربر"}
            </span>
            <ArrowDown2 strokeWidth={4} size={16} color="#000" />
          </Button>
        }
      >
        <Link href="/dashboard/profile">پروفایل</Link>
        <Link href="/dashboard/order">سفارشات</Link>
        <Button onClick={() => setIsModalVisible(true)} className="text-base!">
          خروج
        </Button>
      </DropdownMenu>
      {isModalVisible && (
        <ConfirmToast
          cancelText="خیر"
          confirmText="بله"
          closeToast={() => setIsModalVisible(false)}
          confirmFunc={logOutUserFromWebsite}
          confirmMessage="آیا از حساب کاربری خارج می‌شوید؟"
        />
      )}
    </>
  );
}

export default UserDropDown;
